import React from 'react';
import { ArrowRightIcon, TagIcon } from 'lucide-react';
interface CTAButtonProps {
  productName?: string;
  regularPrice?: string;
  salePrice?: string;
  discount?: string;
  url?: string;
  trackingName?: string;
}
const CTAButton22: React.FC<CTAButtonProps> = ({
  productName = 'Glokore - Hair Regrowth Cap',
  regularPrice = '$220.00',
  salePrice = '$109.99',
  discount = '50% OFF',
  url = 'https://glokore.com/haircap/checkout4/?affId=nva&unit=1&uid=3215&c2=886&c1=877',
  trackingName = 'Glokore Red Light Hair Cap'
}) => {
  const handleClick = () => {
    // Track click event with Facebook Pixel
    try {
      if (window.fbq) {
        window.fbq('track', 'Lead', {
          content_name: trackingName,
          content_category: 'Health',
          value: parseFloat(salePrice.replace('$', '')),
          currency: 'USD'
        });
      }
    } catch (error) {
      console.error('Facebook Pixel tracking error:', error);
    }
  };
  // Always use the specified URL
  const buttonUrl = 'https://glokore.com/haircap/checkout4/?affId=nva&unit=1&uid=3215&c2=886&c1=877';
  return <div className="w-full max-w-md mx-auto border border-gray-300 rounded-lg p-4 bg-white" data-id="element-1208">
      <div className="flex items-center gap-1.5 mb-2" data-id="element-1209">
        <TagIcon className="h-3.5 w-3.5 text-gray-600" data-id="element-1210" />
        <span className="text-xs font-medium text-gray-600 uppercase tracking-wide" data-id="element-1211">
          READER ACCESS
        </span>
      </div>

      <h3 className="text-base font-serif font-medium text-gray-900 mb-1.5" data-id="element-1212">
        {productName}
      </h3>

      <div className="flex items-center gap-1.5 mb-3" data-id="element-1213">
        <span className="text-sm text-gray-400 line-through" data-id="element-1214">
          {regularPrice}
        </span>
        <span className="text-base font-medium text-green-600" data-id="element-1215">
          {salePrice}
        </span>
        <span className="bg-yellow-100 text-yellow-800 text-xs font-semibold px-2.5 py-1 rounded" data-id="element-1216">
          {discount}
        </span>
      </div>

      <a href={buttonUrl} onClick={handleClick} target="_blank" rel="noopener noreferrer" className="block w-full bg-gray-900 hover:bg-gray-800 text-white font-medium text-base py-3 px-6 rounded transition-colors duration-200 text-center" data-id="element-1217">
        <span className="flex items-center justify-center gap-2" data-id="element-1218">
          Access Offer
          <ArrowRightIcon className="h-4 w-4" data-id="element-1219" />
        </span>
      </a>
    </div>;
};
export default CTAButton22;